import { useEffect, useState } from "react";

const KEY = "qc-cookie-consent";
const EVENT = "qc-consent-change";

export const getConsent = () => localStorage.getItem(KEY) || sessionStorage.getItem(KEY) || "";

export const setConsent = (value) => {
  if (value === "accepted") {
    localStorage.setItem(KEY, value);
  } else {
    localStorage.removeItem(KEY);
    sessionStorage.setItem(KEY, value);
  }
  window.dispatchEvent(new Event(EVENT));
};

export const useCookieConsent = () => {
  const [consent, set] = useState(getConsent);
  useEffect(() => {
    const sync = () => set(getConsent());
    window.addEventListener(EVENT, sync);
    return () => window.removeEventListener(EVENT, sync);
  }, []);
  return consent;
};
